<template>
  <div>
    <h1>Dashboard Dirección</h1>
  </div>
</template>

<script>
export default {
  name: 'DashboardDireccion'
}
</script>